import { c as _c } from "react/compiler-runtime";
import type { DocumentSide } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useDocumentUploadSideText = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "fieldset.documents.details.side"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    const sideLabelMapping = {
      front: t1,
      back: t2,
      selfie: t3,
      selfie_video: t4
    };
    t5 = side => sideLabelMapping[side];
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default useDocumentUploadSideText;
function _temp($) {
  return $.front;
}
function _temp2($_0) {
  return $_0.back;
}
function _temp3($_1) {
  return $_1.selfie;
}
function _temp4($_2) {
  return $_2.selfieVideo;
}